<!-- 乘机人 列表 -->
<template>
  <div class="traver">
    <van-cell
      :title="title"
      :border="false"
    >
      <span
        v-show="addButton"
        class="addCxr main-color"
        @click="openEmplist"
      >
        + {{ $t('B001', '添加') }}
      </span>
    </van-cell>
    <!--  -->
    <div class="van-hairline--top">
      <van-cell
        v-for="(psg, index) in list"
        :key="index"
      >
        <!-- 儿童 -->
        <!-- <van-row
          v-if="psg.passengerType == 2"
          type="flex"
          align="center"
        >
          <van-col
            class="delete"
            @click="deletePsg(index)"
            v-show="disabled==false"
          >
            <ld-icon
              class="red"
              type="iconjianshao"
            />
          </van-col>

          <van-col :span="24">
            <div class="font16 font-md">
              {{ psg.empName }}
              <van-tag plain>
                {{ psg.passengerType | passengerType }}
              </van-tag>
            </div>
            <div class="font12 gray mt5">
              使用{{ psg.empName }}的证件取票
            </div>
          </van-col>
        </van-row> -->

        <!-- 成人 -->
        <van-row
          type="flex"
          align="center"
        >
          <van-col
            :span="2"
            class="delete"
            @click="deletePsg(index, psg)"
            v-show="disabled == false"
          >
            <ld-icon
              class="red"
              type="iconjianshao"
            />
          </van-col>

          <van-col
            :span="disabled == false ? 20 :24"
            @click="editPsg(psg)"
          >
            <van-row>
              <van-col span="13">
                <div class="font16 font-md">
                  <!-- <span v-if="cplx=='10902'">{{ psg.engName }}</span>
                  <span v-else> {{ psg | getName }}</span>&nbsp; -->
                  <span > {{ psg | getName }}</span>&nbsp;
                  <van-tag plain>
                    <span v-if="psg.psgType == 1">成人</span>
                    <span v-else-if="psg.psgType == 2">儿童</span>
                    <span v-else-if="psg.psgType == 3">婴儿</span>
                    <span v-else>{{ psg.psgType | passengerType }}</span>
                  </van-tag>
                  &nbsp;
                  <van-tag
                    plain
                    type="danger"
                    v-show="psg.isCivil==1&&cplx==10901"
                  >
                    {{ psg.isCivil == 1 ? '公务员' : '' }}
                  </van-tag>
                </div>
              </van-col>
              <van-col
                span="11"
                class="text-right"
              >
                <!--                <span-->
                <!--                  v-show="psg.tkno"-->
                <!--                  class="font12 black"-->
                <!--                > {{ $t('F005', '票号') }}：{{ psg.tkno }}</span>-->
              </van-col>
            </van-row>

            <van-row
              class="font12 gray mt5"
              v-show="showCard"
            >
              <van-col span="18">
                <span v-if="!psg.cardType || psg.cardType == 1 || psg.cardType == 'NI'">
                  <span v-if="falseType">{{ psg.idType | cardType }}&nbsp;</span>
                  {{ trliner[psg.idType] }}
                  <span v-if="falseType && (psg.cardNo || psg.idNumb)">
                    <!-- {{psg.idNumber ? psg.idNumber.replace(/^(.{4})(?:\w+)(.{4})$/, "\$1*****\$2") : psg.cardNo ? psg.cardNo.replace(/^(.{4})(?:\w+)(.{4})$/,"\$1*****\$2") : ""}} -->
                    {{ psg.cardNo ? psg.cardNo.replace(/^(.{4})(?:\w+)(.{4})$/,"\$1*****\$2") : psg.idNumber ? psg.idNumber.replace(/^(.{4})(?:\w+)(.{4})$/, "\$1*****\$2") : '' }}
                  </span>
                  <span v-else> {{ psg.idNo ? psg.idNo.replace(/^(.{4})(?:\w+)(.{4})$/, "\$1*****\$2") : "" }}</span>
                </span>
                <span v-else-if="psg.cardType == '2' || psg.cardType == 'B'|| psg.cardType == 'PP'">
                  {{ psg.cardName }} {{ psg.cardNo }}
                </span>
                <span v-else-if="psg.cardType">
                  {{ psg.cardName }} {{ psg.cardNo }}
                </span>
              </van-col>
              <van-col
                span="6"
                class="text-right black"
                v-show="psg.salePrice"
              >
                <span class="font10 ">￥</span>
                <span class="font12">{{ psg.salePrice + psg.airportFee + psg.serviceFee + psg.tax }}</span>
              </van-col>
            </van-row>
            <van-row>
              <van-col class="font12 gray">
                {{ $t('F008', '手机号') }}：{{ psg.phoneNumber }}
              </van-col>
            </van-row>
            <van-row>
              <van-col
                class="font12 gray"
                v-if="psg.tkno"
              >
                {{ $t('F005', '票号') }}：{{ psg.tkno }}
              </van-col>
            </van-row>
            <van-row />
            <div
              v-show="psg.isCivil==1&&cplx==10901"
              class="font12"
            >
              <div
                class="gray"
                v-show="psg.civilCheck==1&&psg.civilBankName"
              >
                公务卡验证：{{ psg.civilBankName }}
              </div>
              <div
                class="gray"
                v-show="psg.civilCheck==2&&psg.unitAddress"
              >
                预算单位验证：{{ psg.unitAddress }}
              </div>
              <div class="red">
                {{ psg.isCivilError }}
              </div>
            </div>
          </van-col>

          <van-col
            :span="2"
            class="edit"
            @click="editPsg(psg)"
            v-show="disabled == false"
          >
            <ld-icon
              class="gray"
              type="iconright"
            />
          </van-col>
        </van-row>
      </van-cell>
    </div>

    <emp-list
      ref="empList"
      :cplx="cplx"
      :person-list="personList"
      @selected="empCallBack"
      :element="element"
      :radio="radio"
      @radioSelected="radioSelected"
    />

    <ld-edit-psg
      ref="ldEditPsg"
      :cplx="cplx"
      :psg-info="psgInfo"
      @selected="getEditPsg"
      :element="element"
    />
    <tkint-edit-psg
      ref="tkintEditPsg"
      :cplx="cplx"
      :traver.sync="psgInfo"
      @selected="getEditPsg"
      :element="element"
    />
  </div>
</template>

<script>
import {Cell, Tag} from 'vant'
import empList from 'Components/ldEmpList/index.vue'
import ldEditPsg from 'Components/ldEditPsg/index.vue'
import tkintEditPsg from 'Views/TkInt/components/editPsg'
import STATUSMAP from 'Utils/enum'
import { isGat } from 'Utils/gattools'
import { isTusi } from '@/business/utils/tusitools'

export default {
  name: 'Traver',
  components: {
    empList,
    ldEditPsg,
    [Cell.name]: Cell,
    [Tag.name]: Tag,
    tkintEditPsg
  },
  props: {
    travelerList: {//需要展示的出行人
      type: [Array, Object],
      required: true,
      default: function () {
        return []
      }
    },
    personList: {//出差申请单中乘机人集合
      type: [Array, Object],
      default: function () {
        return []
      }
    },
    title: {
      type: String,
      default: '乘机人'
    },
    disabled: {
      //禁止滑动
      type: Boolean,
      default: false
    },
    addButton: {
      //显示增加 按钮
      type: Boolean,
      default: true
    },
    zclx: {
      //政策类型
      type: String,
      default: 'zcGnjp'
    },
    cplx: {
      //产品类型
      type: String,
      default: '10901'
    },
    showCard: {
      type: Boolean,
      default: true
    },
    element: {
      type: String,
      default: ''
    },
    radio: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      psgInfo: {},
      cplxObj: {
        '10901': 'tk',
        '10902': 'tkInt',
        '10903': 'ht',
        '10906': 'car',
        '10913': 'visa'
      }, // 根据产品缓存 选中出行人
      list: [],
      storeName: 'tk/travelerList',
      cardType: '',
      STA: '',
      trliner: '',
      falseType: true
    }
  },
  created() {
    this.storeName = `${this.cplxObj[this.cplx]}/travelerList`
    const url = window.location.href
    if (url.includes('tk/tkCmp')) {
      this.falseType = false
    } else if (url.includes('tk/tkEdit')) {
      this.falseType = true
    } else if (url.includes('tk/tkOrderDetail')) {
      this.falseType = false
    } else if (url.includes('tk/wfOrderDetail')) {
      this.falseType = false
    } else {
      this.falseType = true
    }
  },
  methods: {
    radioSelected(info) {
      this.list = [info]
      this.$store.commit(this.storeName, [info])
    },
    empCallBack(info) {
      this.$store.commit(this.storeName, info)
    },
    getEditPsg(info) {
      var idx = 0
      this.list.forEach((item, index) => {
        if (item.clkFlag == 1) { // 附属人
          if (info.clkFlag == 1) {
            if (item.contactsId == info.contactsId) {
              item = info
              idx = index
            }
          }
        } else if (item.clkFlag == 0) { // 常旅客
          if (info.clkFlag == 0) {
            if (item.contactsId == info.contactsId) {
              item = info
              idx = index
            }
          }
        } else if (item.clkFlag == 2) {// 员工
          if (info.clkFlag == 2) {
            if (item.empId == info.empId) {
              item = info
              idx = index
            }
          }
        } else {
          if (item.personId == info.personId) {
            item = info
            idx = index
          }
        }

        if (item.passengerType) {
          item.psgType = item.passengerType
        }
      })
      Object.assign(this.list[idx], info)
      this.$store.commit(this.storeName, this.list)
      this.$emit('selected', this.list)
      this.$forceUpdate() // 强制更新
    },
    editPsg(psg) {
      // const userInfo = localget('userInfo') || {};
      // if (userInfo && userInfo.vipCorp && userInfo.vipCorp.bookStyle && userInfo.empInfo) {
      //   // 申请单模式用户端统一不能修改人员信息
      //   if (userInfo.vipCorp.bookStyle === 2) {
      //     this.$dialog({message: '不能修改人员信息'});
      //     return;
      //   }
      //   if (userInfo.vipCorp.bookStyle === 1 && userInfo.empInfo.xgygxx === 0) {
      //     this.$dialog({message: '不能修改人员信息'});
      //     return;
      //   }
      // }

      if (this.disabled == false) {
        this.psgInfo = psg
        // if (this.cplx == '10902') {
        //   this.$refs.tkintEditPsg.toggle() //国际机票
        // } else {
        //   this.$refs.ldEditPsg.toggle() //国内机票
        // }
        if(isGat()){//关爱通的情况下
          if (this.cplx == '10902') {
            this.$router.push('/tk/tkIntEdit');
          } else {
            this.$router.push('/tk/tkEdit');
          }
        }
        this.$refs.ldEditPsg.toggle(this.cplx)

      }
    },
    // 删除乘车人
    deletePsg(index, curPsg) {
      this.list.splice(index, 1)
      //当一个成人添加了儿童，删除成人后，关联的儿童也要自动删除
      if (curPsg && (curPsg.passengerType == 1 || !curPsg.passengerType)) {
        this.list = this.list.filter((psg) => !(curPsg.cardNo === psg.cardNo && psg.passengerType === 2))
      }
      this.$store.commit(this.storeName, this.list)
      this.$emit('selected', this.list)
    },
    openEmplist() {
      if(isGat()){//关爱通的情况下
        if (this.cplx == '10902') {
          this.$router.push('/tk/tkIntEdit');
        } else {
          this.$router.push('/tk/tkEdit');
        }
      }
      if(isTusi()){
        this.$refs.empList.toggle({index: 0, showTabIndex:[0]})
      } else {
        this.$refs.empList.toggle({index: 1})
      }
      this.$emit('se', this.list)
    },
    toggle() {
      this.isShow = !this.isShow
    }
  },
  filters: {
    passengerType(val) {
      if (val == 2) {
        return '儿童'
      } else {
        return '成人'
      }
    }
  },
  watch: {
    'travelerList.length': {
      handler: function (val) {
        let arr = this.travelerList

        arr.forEach(item => {
          if (!item.cardType) {
            if (item.cardNo) {
              item.cardType = 'NI'
            } else if (item.passport) {
              item.cardType = 'PP'
              item.cardName = '护照'
            } else if (item.otherNumber) {
              item.cardType = 'UU'
              item.cardName = '其它证件'
            }
          }
        })
        this.trliner = STATUSMAP
        this.list = arr
      },
      deep: true,
      immediate: true
    },
  }
}
</script>

<style lang="less" scoped>
.traver {
  .addCxr {
    display: inline-block;
    padding: 0px 10px;
    border-radius: 15px;
    text-align: center;
    font-size: @font-size-14;
    border-width: 1px;
    border-style: solid;
  }
}
</style>
